import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

/**
 * Upload a single staged file (manifest, cover, or pdf).
 * Accepts { importId, file, type, onProgress }.
 */
const useUploadBulkImportFile = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	return useMutation(
		async ({ importId, file, type, onProgress }) => {
			const instance = await InitApi(
				{ accessToken },
				"multipart/form-data"
			);
			const formData = new FormData();
			formData.append("file", file);
			formData.append("type", type);

			const response = await instance.post(
				`/publisher/bulk-book-imports/${importId}/uploads`,
				formData,
				{
					onUploadProgress: (event) => {
						if (!onProgress || !event.total) return;
						onProgress(Math.round((event.loaded * 100) / event.total));
					},
				}
			);

			return response.data?.data;
		},
		{
			onSuccess: (_data, variables) => {
				queryClient.invalidateQueries([
					"bulkBookImport",
					variables.importId,
				]);
			},
			onError: (error) => {
				toast.error(
					<ServerErrors
						errorMessage={error?.response?.data?.message}
						errors={error?.response?.data?.data}
					/>
				);
			},
		}
	);
};

export default useUploadBulkImportFile;
